<template lang="pug">
  div
    v-bottom-sheet(v-model="variantSheet" max-width="600px" scrollable)
      v-card(flat)
        v-card-text.pa-0(style="color: rgba(0, 0, 0, 1);")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          div.pb-2(v-else)
            template(v-for="(variant, index) in variantProducts")
              v-divider.white(v-if="index !== 0")
              div.pa-4.d-flex(@click="openShowVariant(index)" :style="!variant.showVariant ? 'background-color: var(--v-infoT08)': ''")
                div.pr-1
                  div.s1.mb-1 {{ variant.quantity && variant.quantity >= 1 ? variant.quantity + ' x ' + product.name : product.name }}
                  div.p2(v-if="variant.id") {{ variant.name }}
                v-spacer
                div.pl-1(align="right")
                  div.s1(v-if="variant.id") {{ (variant.price * variant.quantity) | displayPrice }}
                  div.s1(v-else-if="priceRange.length > 1") {{ priceRange[0] | displayPrice }} - {{ priceRange[1] | displayPrice }}
                  div.s1(v-else) {{ priceRange[0] | displayPrice }}
                  div.p2.basic600--text(v-if="!variant.showVariant") {{ $t('click_edit') }}
              v-expand-transition
                div.px-4(v-if="variant.showVariant")
                  template(v-for="option in options")
                    div.mb-4(:key="option.id")
                      div.label.basic600--text {{ option.name }}
                      template(v-for="spec in option.specs")
                        v-btn.mr-2.mt-2.text-capitalize.button-Aa-tiny(:color="checkSelected(variant, option.id, spec.id) ? 'info500' : 'grey lighten-3'" :outlined="checkSelected(variant, option.id, spec.id)" :disabled="specDisabled(variant, option.id, spec.id)" small depressed height="24" @click="clickSpec(variant, option, spec)" :key="spec.id") {{ spec.value }}
                  v-row(justify="center")
                    v-layout.mb-4
                      v-spacer
                      v-btn.my-auto(icon small @click="variant.quantity--" :disabled="variant.quantity < 1")
                        eva-icon.mt-1(name="minus-circle-outline" height="24" width="24" :fill="variant.quantity < 1 ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500")
                      v-layout.divbox.s1.my-auto.text-center.mx-3 
                        .s1.ma-auto {{ variant.quantity }}
                      v-btn.my-auto(icon small @click="variant.quantity++" :disabled="addQtyDisabled(variant)")
                        eva-icon.mt-1(name="plus-circle-outline" height="24" width="24" :fill="addQtyDisabled(variant) ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500")
                      v-spacer

          div.pa-4(align="center")
            v-btn(small color="primary500" outlined height="24" :style="{'background-color': $vuetify.theme.themes[$theme].basic600T08}" @click="addProduct" :disabled="!showAddButton")
              eva-icon(name="plus-outline" height="14" width="14" style="margin-bottom: -2px; margin-left: -6px;" :fill="!showAddButton ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500")
              div.button-AA-tiny(:style="{'color': !showAddButton ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500}") {{ $t('add_another') }}

          v-divider.basic300.mt-2

          v-layout.my-6(v-if="hasDiscountPermission")
            v-spacer
            .discount(v-if="discount")
              v-layout
                .s2.primary400--text(v-if="discount.isPercentage") {{ $t('discount') }}: {{ discount.value }}%
                .s2.primary400--text(v-else) {{ $t('discount') }}: {{ discount.value | displayPrice }}
                eva-icon.mt-1.ml-2(name="trash-outline" height="16" width="16" :fill="$vuetify.theme.themes[$theme].danger500" @click="discount = null")
            .button-Aa-medium.info500--text(v-else @click="openEditDiscount = true") {{ $t('add_discount') }}
            v-spacer

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='variantSheet = !variantSheet')
            .button-Aa-medium.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='info500' depressed @click="clickSave()")
            .button-AA-medium.basic100--text {{ $t('save_order') }}
    
    .discount(style="max-width:500px")
      AddDiscount(v-if="openEditDiscount" :open.sync="openEditDiscount" :initialDiscount.sync="discount" @added="handleAddDiscount")

</template>

<script>
import AddDiscount from '@/components/forms/AddDiscount.vue'
import { mapActions } from 'vuex'

export default {
  name: 'Variants',
  components: { AddDiscount },
  props: {
    language: {
      type: String,
      default: 'en'
    },
    open: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    inventory: {
      type: Object,
      default: () => ({})
    },
    hasDiscountPermission: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isFetching: false,
    variants: [],
    variantProducts: [],
    originalVariantProducts: [],
    openEditDiscount: false,
    discount: null
  }),
  computed: {
    variantSheet: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    finalVariants () {
      const copyVarProducts = JSON.parse(JSON.stringify(this.variantProducts))
      let fin = copyVarProducts.reduce((final, data) => {
        const isAlready = final.find(value => value.id === data.id)
        if (!isAlready) {
          final.push(data)
        } else {
          const idx = final.map(m => m.id).indexOf(isAlready.id)
          final[idx].quantity += data.quantity
        }
        return final
      }, [])
      // fin = fin.filter(f => f.quantity > 0)
      if (JSON.stringify(this.originalVariantProducts.map(m => m.id)) === JSON.stringify(this.variantProducts.map(m => m.id))) {
        if (this.hasDiscountPermission) {
          if (this.discount) {
            fin = fin.map(m => { return { ...m, show_discount_as_percentage: this.discount.isPercentage, discount: this.discount.value } })
          } else {
            fin = fin.map(m => { return { ...m, show_discount_as_percentage: false, discount: 0 } })
          }
        }
        const tot = {
          parent_id: this.product.id,
          variant_products: fin
        }
        return tot
      } else {
        let oriVariants = this.originalVariantProducts.map(m => { return { ...m, quantity: 0 } }).filter(f => f.edit_id)
        let newVariants = this.variantProducts.map(m => { return { ...m, edit_id: null } })
        if (this.hasDiscountPermission) {
          if (this.discount) {
            newVariants = newVariants.map(m => { return { ...m, show_discount_as_percentage: this.discount.isPercentage, discount: this.discount.value } })
          } else {
            newVariants = newVariants.map(m => { return { ...m, show_discount_as_percentage: false, discount: 0 } })
          }
        }
        let varArray = oriVariants.concat(newVariants)
        const tot = {
          parent_id: this.product.id,
          variant_products: varArray
        }
        return tot
      }
    },
    totalQuantity () {
      return this.variantProducts.map(m => m.quantity).reduce((total, num) => { return total + num }, 0)
    },
    priceRange () {
      if (this.variants.length > 0) {
        const nums = this.variants.map(m => m.product.price).slice().sort((a, b) => {
          return a - b
        })
        if (nums[0] === nums[nums.length - 1]) {
          return [nums[0]]
        }
        return [nums[0], nums[nums.length - 1]]
      }
      return [0]
    },
    showAddButton () {
      if (this.variantProducts.length > 0) {
        return this.variantProducts[this.variantProducts.length - 1].quantity > 0
      } else {
        return false
      }
    },
    parentDisabled () {
      if (this.inventory.inv_enable) {
        const totalQty = this.variantProducts.map(m => m.quantity).reduce((a, b) => a + b, 0)
        if (totalQty >= this.inventory.inv_qty) {
          return true
        }
      }
      return false
    }
  },
  mounted () {
    this.fetchVariantsProducts()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchVariantsProducts () {
      if (this.product.variant_products) {
        this.variantProducts = [...this.product.variant_products.map((m) => { return { ...m, showVariant: false, nat_prod: null } })]
        this.originalVariantProducts = JSON.parse(JSON.stringify(this.variantProducts))
        this.variantProducts = this.variantProducts.filter(f => f.quantity > 0)
        this.fetchVariants()
      } else {
        const variant = {
          id: null,
          name: null,
          quantity: 0,
          price: null,
          selectedOptions: [],
          showVariant: true
        }
        this.variantProducts.push(variant)
        this.fetchVariants()
      }
    },
    fetchVariants () {
      this.isFetching = true
      this.$axios.get(`/products/${this.product.id}?expand=variants,options`)
        .then((resp) => {
          this.variants = resp.data.variants
          this.options = resp.data.options
        })
        .catch(() => {
          this.$store.commit('message/updateMessage', ['error', 'Unable to complete your request. Please try again later'])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    addProduct () {
      this.closeShowVariant()
      const variant = {
        id: null,
        name: null,
        quantity: 0,
        price: null,
        selectedOptions: [],
        showVariant: true
      }
      this.variantProducts.push(variant)
    },
    clickSpec (variant, option, spec) {
      if (variant.selectedOptions.filter(f => f.id === option.id).length > 0) {
        if (variant.selectedOptions.filter(f => f.id === option.id)[0].selected === spec.id) {
          variant.selectedOptions = variant.selectedOptions.filter(f => f.id !== option.id)
          variant.id = null
          variant.name = null
          variant.price = null
          variant.quantity = 0
          return
        }
        variant.selectedOptions.filter(f => f.id === option.id)[0].selected = spec.id
      } else {
        variant.selectedOptions.push({ id: option.id, name: option.name, selected: spec.id })
      }
      this.selectVariant(variant)
    },
    selectVariant (variant) {
      if (this.options.length > 1) {
        if (variant.selectedOptions.filter(f => f.selected).length > 1) {
          const filteredVariants = this.variants.filter(f => variant.selectedOptions.map(m => m.selected).every(e => f.specs.includes(e)))
          if (filteredVariants.length > 0) {
            const variantData = this.variants.filter(f => variant.selectedOptions.map(m => m.selected).every(e => f.specs.includes(e)))[0]
            if (!variantData.product.inventory_enabled || (variantData.product.inventory_enabled && variantData.product.inventory_qty > 0)) {
              variant.id = variantData.product.id
              variant.name = variantData.product.name
              variant.price = variantData.product.price
              if (variant.quantity === 0 && !this.parentDisabled) {
                variant.quantity = 1
              }
            }
          }
        }
      } else {
        const variantData = this.variants.filter(f => f.specs.includes(variant.selectedOptions[0].selected))[0]
        if (!variantData.product.inventory_enabled || (variantData.product.inventory_enabled && variantData.product.inventory_qty > 0)) {
          variant.id = variantData.product.id
          variant.name = variantData.product.name
          variant.price = variantData.product.price
          if (variant.quantity === 0 && !this.parentDisabled) {
            variant.quantity = 1
          }
        }
      }
    },
    specDisabled (variant, optionId, specId) {
      if (this.options.length > 1) {
        if (variant.selectedOptions.length > 0) {
          if (variant.selectedOptions.length === 1) {
            if (variant.selectedOptions[0].id !== optionId) {
              const filteredVariant = this.variants.filter(f => f.specs.includes(specId) && f.specs.includes(variant.selectedOptions[0].selected))[0].product
              const totalSpecQty = this.variantProducts.filter(f => f.id === filteredVariant.id).map(m => m.quantity).reduce((a, b) => a + b, 0)
              if (variant.id !== filteredVariant.id) {
                if (filteredVariant.inventory_enabled && filteredVariant.inventory_qty <= totalSpecQty) {
                  return true
                } else if (filteredVariant.inventory_enabled && (filteredVariant.inventory_qty - totalSpecQty) < variant.quantity) {
                  return true
                }
              }
            }
            return false
          } else {
            if (!variant.selectedOptions.map(m => m.selected).includes(specId)) {
              const otherSpecId = variant.selectedOptions.filter(f => f.id !== optionId)[0].selected
              const filteredVariant = this.variants.filter(f => f.specs.includes(specId) && f.specs.includes(otherSpecId))[0].product
              const totalSpecQty = this.variantProducts.filter(f => f.id === filteredVariant.id).map(m => m.quantity).reduce((a, b) => a + b, 0)
              if (variant.id !== filteredVariant.id) {
                if (filteredVariant.inventory_enabled && filteredVariant.inventory_qty <= totalSpecQty) {
                  return true
                } else if (filteredVariant.inventory_enabled && (filteredVariant.inventory_qty - totalSpecQty) < variant.quantity) {
                  return true
                }
              }
            }
            return false
          }
        }
        return false
      } else {
        const filteredVariant = this.variants.filter(f => f.specs.includes(specId))[0].product
        const totalSpecQty = this.variantProducts.filter(f => f.id === filteredVariant.id).map(m => m.quantity).reduce((a, b) => a + b, 0)
        if (variant.id !== filteredVariant.id) {
          if (filteredVariant.inventory_enabled && filteredVariant.inventory_qty <= totalSpecQty) {
            return true
          } else if (filteredVariant.inventory_enabled && (filteredVariant.inventory_qty - totalSpecQty) < variant.quantity) {
            return true
          }
        }
        return false
      }
    },
    addQtyDisabled (variant) {
      if (!variant.id) {
        return true
      }
      if (this.parentDisabled) {
        return true
      }
      const filteredVariant = this.variants.filter(f => f.product.id === variant.id)[0].product
      const totalVariantQty = this.variantProducts.filter(f => f.id === filteredVariant.id).map(m => m.quantity).reduce((a, b) => a + b, 0)
      if (filteredVariant.inventory_enabled && filteredVariant.inventory_qty <= totalVariantQty) {
        return true
      }
      return false
    },
    checkSelected (variant, optionId, specId) {
      if (variant.selectedOptions.filter(f => f.id === optionId).length > 0) {
        return variant.selectedOptions.filter(f => f.id === optionId)[0].selected === specId
      }
      return false
    },
    removeAddAnother (idx) {
      this.variantProducts.splice(idx, 1)
      if (this.variantProducts.length === 0) {
        this.variantSheet = false
      }
    },
    openShowVariant (idx) {
      this.variantProducts.forEach((o) => {
        this.$set(o, 'showVariant', false)
      })
      this.$set(this.variantProducts[idx], 'showVariant', true)
    },
    closeShowVariant () {
      this.variantProducts.forEach((o) => {
        this.$set(o, 'showVariant', false)
      })
    },
    handleAddDiscount (val) {
      this.discount = val
    },
    clickSave () {
      this.$emit('finalVariants', this.finalVariants)
      this.$emit('update:inventory', {})
      this.variants = []
      this.variantProducts = []
      this.variantSheet = false
    }
  }
}
</script>

<style lang="scss" scoped>
.divbox {
  border: 2px solid var(--v-basic400);
  background-color: var(--v-basic200);
  height: 40px;
  max-width: 60px;
  border-radius: 5px;
}
</style>

<i18n>
{
  "en": {
    "save_order": "save order",
    "click_edit": "Click to edit"
  },
  "id": {
    "save_order": "simpan order",
    "click_edit": "klik untuk edit"
  }
}
</i18n>